<template>
  <div>
    <div class="btn-group view-mode" role="group">
      <button
        class="btn btn-default is-ics-all"
        :class="{ 'btn-active': !icsType || icsType === 'ics' }"
        type="button"
        @click="changeIcs(null)"
      >
        {{ $t(`find.ALL`) }}
      </button>
      <button
        class="btn btn-default is-ics-i"
        :class="{ 'btn-active': icsType === 'i' }"
        type="button"
        @click="changeIcs('i')"
      >
        {{ indText }}
      </button>
      <button
        class="btn btn-default is-ics-c"
        :class="{ 'btn-active': icsType === 'c' }"
        type="button"
        @click="changeIcs('c')"
      >
        {{ commText }}
      </button>
      <button
        class="btn btn-default is-ics-s"
        :class="{ 'btn-active': icsType === 's' }"
        type="button"
        @click="changeIcs('s')"
      >
        {{ shopsText }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icsType: {},
    short: {
      type: Boolean,
    },
    canUnset: {
      type: Boolean,
      default: () => true,
    },
    textType: {
      type: String,
      default: 'usage',
    },
    isTransaction: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    textSuffix() {
      return this.short ? 'S' : '';
    },
    indText() {
      if (this.textType === 'usage') return this.$t('find.IND_TAB');
      else if (this.textType === 'dept') return this.$t(`find.IND_S`);
    },
    commText() {
      if (this.textType === 'usage') return this.$t('find.COMM_TAB');
      else if (this.textType === 'dept') return this.$t(`find.COMM_S`);
    },
    shopsText() {
      if (this.textType === 'usage') return this.$t('find.SHOP_TAB');
      else if (this.textType === 'dept') return this.$t(`find.SHOP_S`);
    },
  },
  methods: {
    changeIcs(selectedIcs) {
      if (this.canUnset) {
        const icsType = this.icsType === selectedIcs ? null : selectedIcs;
        if (this.isTransaction) return this.$emit('change', { icsType });
        if (this.textType === 'usage') {
          this.$emit('change', { buildingType: icsType });
        } else {
          this.$emit('change', { icsType });
        }
      } else if (this.icsType !== selectedIcs) {
        if (!(!this.icsType && selectedIcs === null)) {
          if (this.isTransaction) return this.$emit('change', { icsType: selectedIcs });
          if (this.textType === 'usage') {
            this.$emit('change', { buildingType: selectedIcs });
          } else {
            this.$emit('change', { icsType: selectedIcs });
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.btn,
.btn:hover,
.btn:focus,
.btn:active {
  background-color: #ffffbb;
  outline: none;
}

.btn.btn-active.is-ics-all {
  color: #ffffff;
  background-color: #9d9d9d;
}

.btn.btn-active.is-ics-i {
  color: #ffffff;
  background-color: #47337c;
}

.btn.btn-active.is-ics-c {
  color: #ffffff;
  background-color: #008cba;
}

.btn.btn-active.is-ics-s {
  color: #ffffff;
  background-color: #da4e00;
}

.is-ics-all,
.is-ics-i,
.is-ics-c,
.is-ics-s {
  font-size: 16px;
}
</style>
